import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Default from './Default'
import ErrorPage from '../ErroPage/ErrorPage'

const DynamicRouteHandler = () => {
    const { dynamicPath } = useParams()
    const [couponId, setCouponId] = useState(null)

    let slug
    if (dynamicPath.startsWith('cupom-desconto-')) {
        slug = dynamicPath.replace('cupom-desconto-', '')
    } else if (dynamicPath.startsWith('hot-area-')) {
        slug = dynamicPath.replace('hot-area-', '')
    } else {
        return <ErrorPage />
    }

    return <Default slug={slug} couponId={couponId || null} />
}

export default DynamicRouteHandler
